import React, { Component } from "react";

import { FlowCard } from "./UI/FlowCard";

import * as pr from "../../common/PrimeComponents";
import { LoadScreen } from "../Common/LoadScreen";
import { FlowViewModel } from "./legacy/Wizard/FlowViewModel";
import * as Format from "../../common/FormatFunctions";
import * as log from "../../common/Feedback/Log";
import * as Feedback from "../../common/Feedback/Feedback";
import { CrudlStatus } from "../../common/config/AppConstants";
import { FlowVisual } from "./UI/FlowVisual";

export class Flows extends Component {
  //THOUGHT I MIGHT NEED MORE HERE
  constructor(props) {
    super(props);
    this.state = {
      editView: false,
      showSaveDialog: false
    };
  }
  componentDidMount = () => {};

  componentDidUpdate = () => {
    console.log("HELLO WORLD");
  };

  updateBean = (field, value) => {
    var bean = this.props.currentFlowBean;
    bean[field] = value;

    this.props.updateValue("flowRequest", bean);
  };

  toggleView = booleanValue => {
    this.setState({ editView: booleanValue });
  };

  toggleDialog = booleanValue => {
    this.setState({ showSaveDialog: booleanValue });
  };

  render() {
    return (
      <React.Fragment>
        <div className="ui-g-12">
          {this.props.crudlState !== CrudlStatus.CREATE && (
            <pr.Button
              icon={"pi pi-image"}
              label={"Visualise"}
              style={{ float: "right" }}
              onClick={e => {
                this.toggleView(true);
              }}
            ></pr.Button>
          )}
          {/* <pr.Dialog
            header={"Save before Viewing"}
            footer={
              <div>
                <pr.Button
                  className="secondary-btn"
                  label="Save and View"
                  icon="pi pi-check"
                  onClick={() => {
                    this.toggleDialog(false);
                    this.toggleView(true);
                    //this.props.crudlExecute(true);
                  }}
                  style={{
                    backgroundColor: "black",
                    color: "white",
                    float: "right"
                  }}
                />
                <pr.Button
                  className="secondary-btn"
                  label="Continue Editing"
                  icon="pi pi-times"
                  onClick={() => {
                    this.toggleDialog(false);
                  }}
                  style={{
                    backgroundColor: "black",
                    color: "white",
                    float: "right"
                  }}
                />
              </div>
            }
            visible={this.state.showSaveDialog}
            style={{
              width: "50vw",
              backgroundColor: "#043066",
              color: "white"
            }}
            modal={false}
            onHide={e => this.toggleDialog(false)}
          >
            {"You must save before viewing the Flow Diagram"}
          </pr.Dialog> */}
          {this.state.editView === true && (
            <pr.Sidebar
              visible={true}
              fullScreen={true}
              onHide={e => {
                this.toggleView(false);
              }}
            >
              <FlowVisual
                flowBean={this.props.currentFlowBean}
                fullComponentList={this.props.allComponents}
              />
            </pr.Sidebar>
          )}
          {this.state.editView === false && (
            <FlowCard
              type={this.props.type}
              typeDisplay={this.props.typeDisplay}
              editedObject={this.props.currentFlowBean}
              stationMap={this.props.stationMap}
              componentList={this.props.componentList}
              updateValue={this.updateBean}
            />
          )}
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Flows/Flows.js